import { Component, OnInit, ViewChild } from '@angular/core';
import { AdministrationService } from 'src/app/services/administration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatTableDataSource, MatDialogRef, MatDialog, MatPaginator, MatSort, PageEvent } from '@angular/material';
import { ProgressSpinnerDialogComponent } from 'src/app/progress-spinner-dialog/progress-spinner-dialog.component';
import { NationalUser } from 'src/app/models/nationalUser';
import { PaginationModel } from 'src/app/models/shared-models';

@Component({
  selector: 'app-national-user-list',
  templateUrl: './national-user-list.component.html',
  styleUrls: ['./national-user-list.component.scss']
})
export class NationalUserListComponent implements OnInit {

  loading = true;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns: string[] = ['memberNo', 'firstName', 'lastName', 'contact', 'email', 'active', 'admin'];
  lookupTimerForSearh = null;
  searchText: string = '';
  length: number;
  dataSource: MatTableDataSource<NationalUser>;
  dialogRef: MatDialogRef<ProgressSpinnerDialogComponent>;
  constructor(private adminService: AdministrationService, private router: Router, private route: ActivatedRoute, private dialog: MatDialog) { }

  ngOnInit() {
    this.dataSource = new  MatTableDataSource<NationalUser>();
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.loading = false;
    this.GetData(new PaginationModel(1, 15,this.searchText, this.sort.active, this.sort.direction));
  }

  onAddNationalUser() {
    this.router.navigate(['./', -1], { relativeTo: this.route });
  }

  onEditNationalUser(userId: string) {
    this.router.navigate(['./', userId], { relativeTo: this.route });
  }

  onMarkActive() {
    this.router.navigate(['./set-as-active'], { relativeTo: this.route });
  }

  private GetData(pagination: PaginationModel) {
    this.dialogRef = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    this.adminService.GetAllNationalUsers(pagination).subscribe(result => {
      this.dialogRef.close();
      this.length = result.count;
      this.dataSource = new MatTableDataSource<NationalUser>(result.data);
      this.dataSource.sort = this.sort;
    }, error => {
      this.dialogRef.close();
    });
  }

  onPageChange(value: PageEvent) {
    this.GetData(new PaginationModel(value.pageIndex+1,value.pageSize,this.searchText, this.sort.active, this.sort.direction));
}

onSearchChange(event: any) {
  this.searchText = event;
  clearTimeout(this.lookupTimerForSearh);
  this.lookupTimerForSearh = setTimeout(() => {
    this.GetData(new PaginationModel(1,this.paginator.pageSize,this.searchText, this.sort.active, this.sort.direction))
  }, 1000);
}
}
